import React, { useState } from 'react';
import './WhatsAppButton.css';

const WhatsAppButton = ({ phoneNumber = "1234567890", message = "Hello!" }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [customMessage, setCustomMessage] = useState(message);

  const handleOpenModal = () => {
    setCustomMessage(message);
    setIsModalOpen(true);
  };

  const handleSend = () => {
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(customMessage)}`;
    window.open(whatsappURL, '_blank');
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <button
        className="whatsapp-button"
        onClick={handleOpenModal}
        aria-label="Contact us on WhatsApp"
        title="Contact us on WhatsApp"
      >
        <img src="/socialIcons/Whatsapp.svg" alt="WhatsApp" />
      </button>

      {/* Modal Overlay */}
      {isModalOpen && (
        <div className="whatsapp-modal-overlay" onClick={handleCancel}>
          {/* Modal Container */}
          <div className="whatsapp-modal" onClick={(e) => e.stopPropagation()}>
            <div className="whatsapp-modal-header">
              <h3>Send Message via WhatsApp</h3>
              <button
                className="whatsapp-modal-close"
                onClick={handleCancel}
                aria-label="Close modal"
              >
                ×
              </button>
            </div>

            <div className="whatsapp-modal-body">
              <label htmlFor="whatsapp-message">Customize your message:</label>
              <textarea
                id="whatsapp-message"
                value={customMessage}
                onChange={(e) => setCustomMessage(e.target.value)}
                placeholder="Enter your message here..."
                rows={5}
                className="whatsapp-modal-textarea"
              />
              <p className="whatsapp-modal-help">
                Message will be sent to: <strong>{phoneNumber}</strong>
              </p>
            </div>

            <div className="whatsapp-modal-footer">
              <button
                className="whatsapp-modal-button cancel"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="whatsapp-modal-button send"
                onClick={handleSend}
                disabled={!customMessage.trim()}
              >
                Send via WhatsApp
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WhatsAppButton;
